export const ROUTE_PATH = 'CURRENT_ROUTE'
export const SET_CURRENT_ORG = 'SET_CURRENT_ORG'
export const SET_ORG_LIST = 'SET_ORG_LIST'
export const SET_THEME = 'SET_THEME'
export const SET_ORG_PERMISSIONS = 'SET_ORG_PERMISSIONS'

export interface IOrgsRedux {
    selectedOrg?: { id: any, orgName: any, owner: any},
    orgList?: any[],
    selectedTheme?: {},
    orgPermissions?: any[]
}

interface CurrentRouteAction {
    type: typeof ROUTE_PATH | typeof SET_CURRENT_ORG | typeof SET_ORG_LIST | typeof SET_THEME | typeof SET_ORG_PERMISSIONS
    data: IOrgsRedux
  }


export type CurrentRouteActionTypes = CurrentRouteAction;